<!--
 * @创建文件时间: 2019-10-29 15:53:34
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-01 23:47:23
 * @联系Qq:1638245306
 * @文件介绍: 底部菜单栏
 -->
<template>
    <div style="height:20px">
            <el-row style="font-size: 14px;line-height:20px">
                <el-col :span="6">制单人:{{(billingInfo.createUserName?billingInfo.createUserName:billingInfo.createUser)}}</el-col>
                <el-col :span="6">制单时间:{{billingInfo.makingTime?billingInfo.makingTime:billingInfo.createTime}}</el-col>
                <el-col :span="6">最后修改人:{{(billingInfo.updateUserName?billingInfo.updateUserName:billingInfo.updateUser)}}</el-col>
                <el-col :span="6">最后修改时间:{{billingInfo.updateTime}}</el-col>
            </el-row>

    </div>
</template>

<script>
  export default {
    name: 'billingInfo',
    props:{
      billingInfo:{
        type:Object,
        default:()=>{
          return {
            createUser:'',
            createUserName:'',
            updateUser:'',
            updateUserName:'',
            createTime:'',
            updateTime:'',
            makingTime:"",
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/billingInfo.vue"
}
</vue-filename-injector>
